import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-foreground-400 text-sm font-medium mb-2">Latest SEO Guides</p>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 italic">
              GTBuy Spreadsheet Insights
            </h2>
          </div>
          <p className="text-foreground-600 text-sm max-w-md leading-relaxed">
            In-depth guides and comparisons to help you master spreadsheet-based shopping systems and make better buying decisions
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => {
            if (idx === 5) {
              return (
                <div key={article.slug} className="bg-foreground-900 rounded-2xl overflow-hidden group cursor-pointer flex flex-col">
                  <div className="p-6 md:p-7 flex flex-col justify-between flex-grow">
                    <div>
                      <span className="inline-block px-3 py-1 bg-accent-500/20 text-accent-300 text-xs font-semibold rounded-full mb-4">
                        {article.tag}
                      </span>
                      <h3 className="font-heading text-xl font-bold text-background-50 mb-3 leading-snug">
                        {article.title}
                      </h3>
                      <p className="text-foreground-400 text-sm leading-relaxed line-clamp-3">
                        {article.excerpt}
                      </p>
                    </div>
                    <Link
                      to={article.slug}
                      className="inline-flex items-center gap-2 mt-5 text-accent-400 text-sm font-medium hover:text-accent-300 transition-colors whitespace-nowrap"
                    >
                      Read Article
                      <i className="ri-arrow-right-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
                    </Link>
                  </div>
                </div>
              );
            }

            return (
              <Link
                key={article.slug}
                to={article.slug}
                className="group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-colors duration-300 flex flex-col"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 flex flex-col flex-grow">
                  <span className={`inline-block px-3 py-1 text-xs font-semibold rounded-full mb-3 w-fit ${article.tagColor}`}>
                    {article.tag}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 flex-grow">
                    {article.excerpt}
                  </p>
                  <span className="inline-block mt-3 text-xs text-primary-600 font-medium group-hover:underline inline-flex items-center gap-1">
                    Read Article
                    <i className="ri-arrow-right-line text-xs w-3 h-3 flex items-center justify-center"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}